/* eslint-disable */
import 'core-js';

import 'whatwg-fetch';
import 'raf/polyfill';

import fromEntries from 'object.fromentries';
if (!Object.fromEntries) {
  fromEntries.shim();
}

import 'intl';

// Polyfill for crypto.randomUUID() for older browsers
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = function () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  };
}
